import { Edit } from 'react-admin';
import { SettingForm } from './Setting.Form';

export const SettingEdit = () => {
    return (
        <Edit>
            <SettingForm />
        </Edit>
    );
};
